import {ButtonProps} from '@mui/material';
import Button from '@mui/material/Button';

import {useIsDownSm} from 'utils/hooks/useMediaQuery';

type SecondaryActionButtonProps = Omit<ButtonProps, 'variant' | 'fullWidth'>;

export const SecondaryActionButton = (props: SecondaryActionButtonProps) => {
  return <Button variant='outlined' fullWidth={useIsDownSm()} {...props} />;
};
